import { camundaApi } from "@/core/api/camundaApi";
import { PURCHASE_EVENT } from "@/core/data";

const ENCODED_AMOUNT: number = 10;

const REQUIRED_VARIABLES: string[] = [
  "airlineName",
  "altTransports",
  "brandId",
  "brandFamily",
  "customerEmail",
  "domain",
  "environment",
  "flightProblem",
  "journeyType",
  "numberOfPassengers",
  "totalClaimAmount",
  "promotionCode",
  "createCaseResponse",
  "partnerClickId",
];

const exposePurchaseEvent = async (): Promise<void> => {
  const transactionId: number = Date.now();

  const {
    data: {
      airlineName,
      altTransports,
      brandId,
      brandFamily,
      customerEmail,
      domain,
      environment,
      flightProblem,
      journeyType,
      numberOfPassengers,
      totalClaimAmount,
      promotionCode,
      createCaseResponse,
      partnerClickId,
    },
  } = await camundaApi.getVariablesForProcess(REQUIRED_VARIABLES);

  window.dataLayer?.push({
    event: PURCHASE_EVENT,
    source: "airspeed-claimcheck",
    environment,
    brandFamily,
    domain,
    journeyType,
    numberOfPassengers,
    alternativeTransportation: !!altTransports?.length,
    incident: flightProblem,
    promotionCode: promotionCode || null,
    legalCasePublicId: createCaseResponse?.legalCasePublicId,
    total_claim_amount: totalClaimAmount,
    email: customerEmail,
    partnerClickId,
    ecommerce: {
      purchase: {
        actionField: {
          id: transactionId,
          revenue: ENCODED_AMOUNT,
        },
        products: [
          {
            name: "claim",
            id: brandId,
            price: ENCODED_AMOUNT,
            category: airlineName,
            variant: flightProblem,
            quantity: 1,
          },
        ],
      },
    },
  });
};

export default exposePurchaseEvent;
